import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import s from './text.module.scss';
export const Text = ({ children, className, onClick }) => (_jsx("p", { className: classNames(s.text, className), onClick: onClick, children: children }));
